<template>
  <div class="ma-2" v-if="tiene_permiso">
    <v-card>
      <v-btn small class="mx-4" @click="$router.back()" color="info" rounded outlined>
        <v-icon>mdi-arrow-left-bold</v-icon> Volver Atras</v-btn
      >
      <v-card-title primary-title>
        <h3 class="headline mb-0">Listado de nits</h3>
        <v-spacer></v-spacer>
        <!-- <download-excel v-if="nits.length" :fields="json_fields" name="nits.xls" :data="nits">
          <v-btn type="button" rounded color="success" dark class="mb-2 mx-2"> <v-icon class="mr-1">mdi-microsoft-excel</v-icon> Exportar </v-btn>
        </download-excel> -->

        <!-- fomulario crear o editar -->
        <create-update-form
          ref="refForm"
          :editedIndex.sync="editedIndex"
          v-on:newregnit="newregnit"
        ></create-update-form>
      </v-card-title>
      <v-card-text class="mt-2">
        <v-data-table
          :items-per-page="-1"
          :loader-height="4"
          :loading="loading"
          :search="search"
          :headers="headers"
          :items="nits"
          class="elevation-1"
          :item-class="itemRowBackground"
        >
          <template v-slot:top>
            <v-toolbar flat>
              <v-text-field
                autofocus
                outlined
                dense
                v-model="search"
                append-icon="mdi-magnify"
                label="Buscar"
                hide-details
              />
            </v-toolbar>
          </template>
          <template #[`item.actions`]="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on" color="success" class="ma-1" @click="detailItem(item)">
                  mdi-eye
                </v-icon>
              </template>
              Ver Detalle
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on" color="info" class="ma-1" @click="editItem(item)">
                  mdi-book-edit
                </v-icon>
              </template>
              Editar
            </v-tooltip>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
    <show-detail ref="refDetails" @showedit="editItem"></show-detail>
  </div>
  <div class="pa-3" v-else>
    <p class="red--text text-center">
      <v-icon color="red">mdi-block-helper</v-icon>
      <br />
      Usuario no autorizado para este visualizar este contenido
    </p>
  </div>
</template>

<script>
  import CreateUpdateForm from './CreateUpdateForm';
  import ShowDetail from './ShowDetail';
  import xaxios from '@/xaxios';

  export default {
    components: {
      CreateUpdateForm,
      ShowDetail,
    },
    data() {
      return {
        search: '',
        tiene_permiso: true,
        editedIndex: -1,
        loading: false,
        headers: [
          { text: 'id', value: 'id' },
          { text: 'Nombre', value: 'nombre' },
          { text: 'Descripcion', value: 'descripcion' },
          { text: 'Numero', value: 'nro' },
          { text: 'Facturacion', value: 'tipo_facturacion' },
          { text: 'Estado', value: 'status' },
          { text: 'Acciones', value: 'actions', sortable: false },
        ],
        nits: [],
        json_fields: {
          id: 'id',
          Nombre: 'nombre',
          Descripcion: 'descripcion',
          Numero: 'nro',
          estado: 'status',
        },
      };
    },
    methods: {
      detailItem(item) {
        this.$refs.refDetails.showDialog(item);
      },
      editItem(item) {
        this.editedIndex = this.nits.indexOf(item);
        this.$refs.refForm.showDialog(item);
      },

      itemRowBackground(item) {
        return item.estado ? '' : 'deshabilitado';
      },

      newregnit(item) {
        let e = this.nits.find((x) => x.id == item.id);
        if (e) {
          e.nombre = item.nombre;
          e.descripcion = item.descripcion;
          e.tipo_facturacion = item.tipo_facturacion;
        }
      },

      getNits() {
        let vue = this;
        this.loading = true;
        var config = {
          method: 'get',
          url: `${process.env.VUE_APP_API_REST}/api/v1/esam/nits`,
          headers: {},
        };

        xaxios.request(config)
          .then(function(response) {
            let data = response.data.data;
            data.map((x) => {
              x.status = x.estado ? 'Activo' : 'Suspendido';
            });
            vue.nits = data;
            window.console.log(data);
            vue.loading = false;
          })
          .catch(function(error) {
            window.console.log(error);
            vue.loading = false;
          });
      },
    },
    async mounted() {
      this.getNits();
    },
  };
</script>
<style>
  .deshabilitado {
    background-color: #ff050033;
  }
</style>
